// Mega menu — tab switching (left category tabs -> right subcategory panel)
 
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu').forEach((megaMenu) => {
    const tabs = Array.from(megaMenu.querySelectorAll('.mega-menu__tab-item'));
    const panels = Array.from(megaMenu.querySelectorAll('.mega-menu__panel'));
    if (!tabs.length || !panels.length) return;

    const activateTab = (index) => {
      tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.tabIndex === index));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.panelIndex === index));
    };

    tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', () => activateTab(tab.dataset.tabIndex));

      const trigger = tab.querySelector('.mega-menu__tab-trigger');
      if (trigger && trigger.tagName === 'SPAN') {
        trigger.addEventListener('click', () => activateTab(tab.dataset.tabIndex));
      }
    });
  });
});
